import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';

import { MsalService } from '@azure/msal-angular';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ReadApprovalsResponseDTO, ReadApprovalsRequestDTO } from '../dtos';

import { BaseService } from './base.service';
import { isAssigned, replaceEmailExt, toISODateString } from '../utils';
import { GlobalsService } from './globals.service';

@Injectable()
export class ApprovalsService extends BaseService {
    private _approvalsUrl: string;

    constructor(private readonly _http: HttpClient, globalsSrv: GlobalsService, authSrv: MsalService) {
        super(globalsSrv, authSrv);

        this._approvalsUrl = `${this.apiUrl}/Work`;
    }

    private requestToAny(request: ReadApprovalsRequestDTO): any {
        const obj: any = { ...request };

        if (isAssigned(request.userApprovalActionFromDt)) obj.userApprovalActionFromDt = toISODateString(request.userApprovalActionFromDt);
        if (isAssigned(request.userApprovalActionToDt)) obj.userApprovalActionToDt = toISODateString(request.userApprovalActionToDt);

        if (isAssigned(request.requestFromDt)) obj.requestFromDt = toISODateString(request.requestFromDt);
        if (isAssigned(request.requestToDt)) obj.requestToDt = toISODateString(request.requestToDt);

        obj.userEmail = replaceEmailExt(request.userEmail);
        obj.userFullName = replaceEmailExt(request.userFullName);
        obj.userStatus = replaceEmailExt(request.userStatus);
        obj.userRoleName = replaceEmailExt(request.userRoleName);
        obj.userRoleStatus = replaceEmailExt(request.userRoleStatus);
        obj.userContextName = replaceEmailExt(request.userContextName);
        obj.userAssociationValues = replaceEmailExt(request.userAssociationValues);
        obj.userProfileName = replaceEmailExt(request.userProfileName);
        obj.userApprovalStatus = replaceEmailExt(request.userApprovalStatus);
        obj.aging = replaceEmailExt(request.aging);
        obj.approverEmail = replaceEmailExt(request.approverEmail);
        obj.approverRoleName = replaceEmailExt(request.approverRoleName);
        obj.filterText = replaceEmailExt(request.filterText);

        return obj;
    }

    readApprovals(request: ReadApprovalsRequestDTO): Observable<ReadApprovalsResponseDTO> {
        const obj = this.requestToAny(request);

        const options = {
            params: this.getHttpParams(obj),
            headers: this.getHttpHeaders(),
        };

        return this._http.get<ReadApprovalsResponseDTO>(this._approvalsUrl, options).pipe(catchError(this.onHttpError));
    }

    exportWorks(format: string, request: ReadApprovalsRequestDTO): Observable<HttpEvent<Blob>> {
        const obj = this.requestToAny(request);

        const params = this.getHttpParams(obj);
        const headers = this.getHttpHeaders();

        return this._http
            .get(`${this._approvalsUrl}/export/${format}`, { params: params, reportProgress: true, observe: 'events', responseType: 'blob', headers: headers })
            .pipe(catchError(this.onHttpError));
    }
}
